import { TextareaDynamicPlaceholder, InputDinamycPlaceholder, ButtonBasic, DropDownSelector } from "@lk-gtcom/ecomlab-components"
import { useState, useEffect } from 'react';
import useGeneralStore from '../../../../store/general';
import customHeaders, { getSpace } from '../../../../common/headers';
import { TitlePage } from '../../../TitlePage/TitlePage';
import { ModalComponent } from "../../ModalComponent/ModalComponent";
import { useResponseHandler } from "../../../../common/auth";
import { usePushNotifications } from "../../../../common/pushNotification";
import './ModalProfileExecutor.scss'

const ModalProfileExecutor = ({
    currentMember,
    setIsModal,
    setCurrentMember
}) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleTableResponse, handleRequestError } = useResponseHandler();
    const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications()

    const [optionsRole, setOptionsRole] = useState([])
    const [selectedRole, setSelectedRole] = useState(null);

    // Контактная информация
    const [name, setName] = useState(currentMember?.name || '')
    const [surname, setSurname] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState(currentMember?.login || '')
    const [organization, setOrganization] = useState('')



    // Получение ролей из пространства
    const fetchGetRoleSpace = () => {
        const abortController = new AbortController();
        const url = `https://apps0.ecomru.ru:4242/api/v2/space/roles/${selectedSpace?.value}`;

        fetch(url, { headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => {
                const options_prop = json?.data?.map(el => ({ label: el?.name, value: el?.id }))
                setOptionsRole(options_prop)
                const curr_role = options_prop?.filter(el => el?.value === currentMember?.role_id)?.[0]
                setSelectedRole(curr_role)
            })
            .catch(handleRequestError)
    };

    // Изменить роль
    const fetchChangeRole = (employee_id) => {
        const url = `https://apps0.ecomru.ru:4242/api/v2/space/users/${selectedSpace?.value}/${currentMember?.id}/role`;

        const body = JSON.stringify({
            role_id: selectedRole?.value
        })

        fetch(url, { method: 'PATCH', headers, body })
            .then(handleTableResponse)
            .then((json) => {
                addSuccessPush('Роль успешно изменена')
            })
            .catch(handleRequestError)
    };

    https://apps0.ecomru.ru:4242/api/v2/space/users/7/899999999/role

    useEffect(() => {
        fetchGetRoleSpace()
    }, []);

    return (
        <ModalComponent
            title='Профиль'
            onClose={(e) => {
                setIsModal(false)
                setCurrentMember(null)
            }}
            style={{
                height: 'auto',
                maxWidth: '1000px'
            }}
            child={
                <div className='modal-profile-executor'>
                    <div className='modal-profile-executor__content'>
                        <div className='modal-profile-executor__block-info'>
                            <TitlePage
                                medium
                                title='Контактная информация'
                            />

                            <InputDinamycPlaceholder
                                changeValue={name}
                                onChange={(e) => setName(e)}
                                placeholder={'Имя'}
                                size='s'
                            />

                            <InputDinamycPlaceholder
                                changeValue={surname}
                                onChange={(e) => setSurname(e)}
                                placeholder={'Фамилия'}
                                size='s'
                            />

                            <InputDinamycPlaceholder
                                changeValue={email}
                                onChange={(e) => setEmail(e)}
                                type='email'
                                placeholder={'Почта'}
                                size='s'
                            />

                            <InputDinamycPlaceholder
                                changeValue={phone}
                                onChange={(e) => setPhone(e)}
                                type='number'
                                placeholder={'Телефон'}
                                size='s'
                            />

                            <InputDinamycPlaceholder
                                changeValue={organization}
                                onChange={(e) => setOrganization(e)}
                                placeholder={'Отдел'}
                                size='s'
                            />

                            <ButtonBasic
                                whiteBlue
                                text='Добавить поля'
                            />
                        </div>

                        <div className='modal-profile-executor__block-info'>
                            <TitlePage
                                medium
                                title='Сменить роль'
                            />

                            <DropDownSelector
                                options_prop={optionsRole}
                                state={selectedRole}
                                setState={setSelectedRole}
                                placeholder="Выберите роль"
                                width="100%"
                                maxWidth='100%'
                                size='s'
                                required
                            />

                            <ButtonBasic
                                green
                                text={'Сохранить'}
                                style={{
                                    marginTop: 'auto'
                                }}
                                disabled={!selectedRole?.value}
                                onClick={fetchChangeRole}
                            />
                        </div>
                    </div>
                </div>
            }
        />
    )
}

export { ModalProfileExecutor }
